import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import organizationFields from '../../fields/organizationFields';
import ORGANIZATION_TYPES from '../../enums/OrganizationTypes';
import { extractDataToSendFromObject } from '@/common-utils/functions/extractDataFromObject';

const mutationAddOrganization = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, organizationInfos }) => {
            const organizationDataToSend = extractDataToSendFromObject(
                organizationInfos,
                [
                    organizationFields.LEGAL_NAME,
                    organizationFields.REGISTRATION_NUMBER,
                    organizationFields.TYPE,
                    organizationFields.CLIENT_CODE,
                    organizationFields.COMMENT,

                    organizationFields.CONNECTION_POINTS,

                    organizationFields.LEGAL_INFOS.REGISTRATION_NUMBER,
                    organizationFields.LEGAL_INFOS.HEAD_OFFICE_REGISTRATION_NUMBER,
                    organizationFields.LEGAL_INFOS.BRANCH_NUMBER,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L1,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L2,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L3,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L4,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L5,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L6,
                    organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L7,
                    organizationFields.LEGAL_INFOS.POSTAL_CODE,
                    organizationFields.LEGAL_INFOS.BUSINESS_POSTAL_CODE,
                    organizationFields.LEGAL_INFOS.CITY_NAME,
                    organizationFields.LEGAL_INFOS.IS_HEAD_OFFICE,
                    organizationFields.LEGAL_INFOS.BUSINESS_NAME,
                    organizationFields.LEGAL_INFOS.BRANCH_BUSINESS_SECTOR_CODE,
                    organizationFields.LEGAL_INFOS.BRANCH_BUSINESS_SECTOR_LABEL,
                    organizationFields.LEGAL_INFOS.COMPANY_LONG_NAME,
                    organizationFields.LEGAL_INFOS.ACRONYM,
                    organizationFields.LEGAL_INFOS.CIVILITY,
                    organizationFields.LEGAL_INFOS.FORNAME,
                    organizationFields.LEGAL_INFOS.LASTNAME,
                    organizationFields.LEGAL_INFOS.EMAIL,
                    organizationFields.LEGAL_INFOS.PHONE,
                    organizationFields.LEGAL_INFOS.HEAD_OFFICE_BRANCH_NUMBER,
                    organizationFields.LEGAL_INFOS.LEGAL_NATURE_CODE,
                    organizationFields.LEGAL_INFOS.LEGAL_NATURE_LABEL,
                    organizationFields.LEGAL_INFOS.COMPANY_BUSINESS_SECTOR_CODE,
                    organizationFields.LEGAL_INFOS.COMPANY_BUSINESS_SECTOR_LABEL,
                    organizationFields.LEGAL_INFOS.CREATION_DATE,
                    organizationFields.LEGAL_INFOS.UPDATE_DATE
                ]
            );

            // Handle merchant organizations : do not create connection points
            // Remove empty connection points and transform string ports to int
            if (organizationDataToSend[organizationFields.TYPE.key] === ORGANIZATION_TYPES.MERCHANT.name) {
                delete organizationDataToSend[organizationFields.CONNECTION_POINTS.key];
            } else {
                organizationDataToSend[organizationFields.CONNECTION_POINTS.key] = (organizationDataToSend[organizationFields.CONNECTION_POINTS.key] || []).filter(
                    connectionPoint => connectionPoint[organizationFields.CONNECTION_POINTS.PORT.key]
                ).map(connectionPoint => ({
                    ...connectionPoint,
                    [organizationFields.CONNECTION_POINTS.PORT.key]: parseInt(connectionPoint[organizationFields.CONNECTION_POINTS.PORT.key], 10)
                }));
            }

            // Remove the legalInfos block if there is nothing beneath it
            if (!organizationDataToSend[organizationFields.LEGAL_INFOS.key][organizationFields.LEGAL_INFOS.REGISTRATION_NUMBER.key]) {
                delete organizationDataToSend[organizationFields.LEGAL_INFOS.key];
            }

            return client.post(
                replaceParameters(ORGANIZATION.COLLECTION.url, { organizationId }), organizationDataToSend
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: (success) => {
            onSuccess(success);
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddOrganization;